import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのPeopleロゴアイコン
 */
export function ProductLogoMediumPeople({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        d="M21.4888 19.2432C21.1221 19.1952 21.0147 18.7451 21.2552 18.4641C22.2172 17.3404 22.7983 15.8809 22.7983 14.2856C22.7983 12.6904 22.2172 11.2309 21.2552 10.1072C21.0147 9.82621 21.1221 9.37608 21.4888 9.32812C21.7031 9.3001 21.9216 9.28564 22.1435 9.28564C24.9049 9.28564 27.1435 11.5242 27.1435 14.2856C27.1435 17.0471 24.9049 19.2856 22.1435 19.2856C21.9216 19.2856 21.7031 19.2712 21.4888 19.2432Z"
        fill="#57D7D9"
      />
      <path
        d="M27.6354 29.2856C27.3068 29.2856 27.0751 28.9546 27.0833 28.6261C27.0838 28.6079 27.084 28.5897 27.084 28.5714V26.4285C27.084 24.6048 26.4005 22.9407 25.2758 21.6784C24.9715 21.3369 25.1967 20.7142 25.6541 20.7142H25.7149C28.8708 20.7142 31.4292 23.2726 31.4292 26.4285V28.5714C31.4292 28.9658 31.1094 29.2856 30.7149 29.2856H27.6354Z"
        fill="#57D7D9"
      />
      <path
        d="M16.3697 19.2856C19.1311 19.2856 21.3697 17.0471 21.3697 14.2856C21.3697 11.5242 19.1311 9.28564 16.3697 9.28564C13.6083 9.28564 11.3697 11.5242 11.3697 14.2856C11.3697 17.0471 13.6083 19.2856 16.3697 19.2856Z"
        fill="#57D7D9"
      />
      <path
        d="M12.7983 20.7142C9.64236 20.7142 7.08398 23.2726 7.08398 26.4285V28.5714C7.08398 28.9658 7.40378 29.2856 7.79827 29.2856H24.9411C25.3356 29.2856 25.6554 28.9658 25.6554 28.5714V26.4285C25.6554 23.2726 23.097 20.7142 19.9411 20.7142H12.7983Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
